import { Injectable } from "@angular/core";
import { take } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { MatDialogSizeService } from "./mat-dialog-size";
import { StoreService } from "./store.service";
import { LoaderService } from "./loader.service";
import { GtmService } from "./gtm-service/gtm.service";
import { MqttEventService } from "./mqtt-event.service";
import { ConfirmationDialogComponent } from "../dialogs/confirmation-dialog/confirmation-dialog.component";

@Injectable({
    providedIn: "root",
})
export class LogoutService {
    public globalChannel = new BroadcastChannel("auth");

    constructor(
        private dialog: MatDialog,
        private router: Router,
        private matDialogSizeService: MatDialogSizeService,
        private storageService: StoreService,
        public loaderService: LoaderService,
        private gtmService: GtmService,
        private mqttService: MqttEventService
    ) {}

    logout(isConfirm: boolean = true): void {
        if (isConfirm) {
            this.dialog
                .open(ConfirmationDialogComponent, {
                    width: this.matDialogSizeService.wIII,
                    disableClose: true,
                    data: {
                        content: "confirm_logout",
                    },
                })
                .afterClosed()
                .pipe(take(1))
                .subscribe((res: any) => {
                    if (res?.confirmed) {
                        this.globalChannel.postMessage({
                            source: "LOGOUT",
                        });

                        this.gtmService.clearUserId(); // Clear user ID from GTM
                        this.storageService.clearAuthStore();
                        this.loaderService.hide();
                        this.dialog.closeAll();
                        this.mqttService.disconnect();
                        this.router.navigate(["/auth/login"]);
                    }
                });
        } else {
            this.globalChannel.postMessage({
                source: "LOGOUT",
            });
            this.gtmService.clearUserId(); // Clear user ID from GTM
            this.storageService.clearAuthStore();
            this.loaderService.hide();
            this.dialog.closeAll();
            this.mqttService.disconnect();
            this.router.navigate(["/auth/login"]);
        }
    }
}
